import { acceptHMRUpdate, defineStore } from 'pinia';
import { useApi } from '@/composables/use-api.ts';
import { EmployeeWithOrganizationDto } from '@/services/api/employee-api.ts';

interface State {
  noToEmployees: { [key: number]: EmployeeWithOrganizationDto };
  keywordToEmployees: { [key: string]: EmployeeWithOrganizationDto[] };
}

export const useEmployeeStore = defineStore('employee', {
  state: (): State => {
    return {
      noToEmployees: {},
      keywordToEmployees: {},
    };
  },

  getters: {},

  actions: {
    async searchAsync(keyword: string) {
      let employees = this.keywordToEmployees[keyword];
      if (employees) return employees;

      const { company } = useApi();
      employees = await company.employee.searchAsync(keyword);
      employees.sort((a, b) => a.name.localeCompare(b.name));
      employees.forEach((employee) => {
        this.noToEmployees[employee.no] = employee;
      });
      return (this.keywordToEmployees[keyword] = employees);
    },
  },
});

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useEmployeeStore, import.meta.hot));
